const toParseCurrency = 100;

export const parseToCents = (value: number) => {
    return value * toParseCurrency;
}

export const parseToCurrency = (cents: number) => {
    return cents / toParseCurrency;
}

export const formatToCents = (value: string) => {
    return parseFloat(value) * 100;
}

export const formatToCurrency =  (cents: number) => {
    return (cents / toParseCurrency).toFixed(2);
}